import { useQuery } from 'react-query';
import { useServiceError } from '@/hooks';
import { getAllRoles, getRolesByProfileId } from './Roles.service';

export function useAllRoles() {
  const query = useQuery(['roles'], () => getAllRoles());

  useServiceError(query.error);

  return query;
}

export function useRolesByProfileId(id: number) {
  const query = useQuery(['roles-profile', id], () => getRolesByProfileId(id));

  useServiceError(query.error);

  return query;
}
